import { AddCustomerLntComponent } from "../app/dashboard/add-customer-lnt/add-customer-lnt.component";
import { AddCustomerNewComponent } from "../app/dashboard/add-customer-new/add-customer-new.component";

export const environment = {
  idString: '_id',
  production: true,
  nameDisplay: false,
  profileType: 'Customer Type',
  projectName: 'apcob',
  digiProject: 'apcobuat',
   customerLogin: false,
  viewCustomerProjectName: 'apcob-uat',
  logo: '../../assets/Apcob_logo.png',
  smallLogo: "../../assets/Apcob_logo.png",
  userRolesListName: "USER_ROLES_GENERIC",
  loginAsUserEnabled: true,
  paymentRequired: false,
  logsRequired: true,
  editOptionOcr: false,
  disableApplyfLoan: true,
  equifaxFileName: "equifax",
  height: "4rem",
  width: "6rem",
  sheight: "3rem",
  swidth: "5rem",
  navList: {
    role_1: 'ADMIN',
    role_2: 'MANAGER',
    role_3: 'LEAD',
    role_4: 'LEAD',
    role_5: 'SALES',
    role_6: 'CREDIT',
    role_7: 'OPERATION',
    role_8: 'OPERATION',
    role_9: 'BC_USER',
    role_10: 'USER',
    role_default: 'NAVIGATION_WTSLN_DEFAULT'
  },
  // logo : '../../assets/rblBank.png',
  key: 'rzp_live_ecI9pp23WCmy2i',
  // key : 'rzp_test_fbWcQYzGIGylZr',
  digiProjectBusiness: '/dashboard/businessKyc/digilocker',
  digiProjectAgri: '/dashboard/AgriKcc/digilocker',
  imageUrlforms: "https://s3.ap-south-1.amazonaws.com/wl-marketplaces",
  addCustomerComponent: AddCustomerNewComponent,



  LOAN_CUSTOMER_TYPE: [
    { id: "1", type: "Salaried" },
    { id: "2", type: "Self Employed - Professional" },
    { id: "3", type: "Pensioner" },
    { id: "4", type: "Businessman" },
    { id: "5", type: "Others" },


    // { codeType: "301159", code: "2", type: "MSME Business" },
    // { codeType: "301159", code: "1", type: "Consumer Retail" },
  ],


  NONINDIVIDUAL_TYPE: [
    { id: "1", type: 'Retail' },
    { id: "2", type: 'Business' },

  ],




  INDIV_OR_NONINDIV: [
    { codeType: "", id: "1", type: "Individual" },
    // { codeType: "", id: "2", type: "Non-Individual" },
  ],
  type: "Customer Type",


  loanTypes: [
    "Proprietary",
    "Partnership",
    "LLP",
    "Private Limited",
    "Trust",
    "Society",
    "AOP",
    "Salaried",
    'Self Employed - Professional',
    'Self Employed - Others',
    "Farmer Agri",
    "Farmer + Salaried",
    "Farmer + Self Employed - Professional",
    "Farmer + Self Employed - Others",
    "Farmer Others",
    "MSME Agri",
    "Gold",
    "Retail",
    "Business",
    "Savings Account",
    "KYC + Bureau",
    "Pensioner",
    "Businessman",
    "Others",
    "Personal Loan",
    "Mortgage Loan",
    "Trader Loan",
    "Gold Loan"
  ],


  displayStatuses: "none",
  // nodeUrl:"https://api-bharatmandi.whatsloan.com",
  nodeUrl: "https://apcob-uat.whatsloan.com",
  encryptRequestUrl: "https://apcob-uat.whatsloan.com/",
  shareKey: "PLACEHOLDERKEY",
  congratsUrlSubDom: "kccnew",
  imageUrl: "https://s3.ap-south-1.amazonaws.com/wl-marketplaces/",
  disableInput: false,
  assistedUrl: "https://bharatmandi.whatsloan.com/landing/assisted-journey",
  frontendUrl: "https://apcob-uat.whatsloan.com/",
  // frontendUrl:"http://localhost:4200/",
  link: "https://apcob-uat.whatsloan.com/landing",
  sseUrl: "https://apcob-uat.whatsloan.com/v1/assist-mode/checkApplicantCompletionStatus?mobileNumber=",

  digilocker: {
    username: 'shriraksh_app',
    apiKey: 'dHofezwquY8KCzJoiTsr',//need to change
    popupUrl: 'https://services.digitallocker.gov.in/index.php',
    docUrl: 'https://partners.digitallocker.gov.in/public/requestor/api/pulldoc/1/xml',

    redirect_Uri: 'https://apcob-uat.whatsloan.com/dashboard/businessKyc/digilocker/fetch',
    clientId: 'EDD69BCD',
    clientSecret: '20fa7d8c71',
    link: 'https://s3.ap-south-1.amazonaws.com/wl-marketplaces/'
  },
  docUrl: 'https://apcob-uat.whatsloan.com/',

  urlSetting: {
    demo: 'https://bharatmandi.whatsloan.com/',
    url: 'https://sfl.sirsiurbanbank.whatsloan.com/',
    ydlUrl: 'http://localhost:4200/laas/financial/bank-statement/transaction',
    live: 'https://sfl.sirsiurbanbank.whatsloan.com/',
  },



  custType: 'Customer',
  panRequired: false,


  privacy: "Privacy Policy,Terms of Use and Refund Policy.",



  salaried: [

    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        //    {
        //    name: 'Credit Report',
        //    link: '/dashboard/businessKyc/crif-report'
        //  },
        // { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
      ],
      isSubmenuVisible: false
    },

    // {
    //   name: 'Address Proof',
    //   icon: 'contacts',
    //   submenu: [

    //     // { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
    //     { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
    //     { name: 'LPG', link: '/dashboard/businessKyc/lpg'}

    //   ],
    //   isSubmenuVisible: false
    // },

    // {
    //   name: 'Income Proof',
    //   faIcon: 'account_balance_wallet',
    //   submenu: [
    //     { name: 'EPF', link: '/dashboard/businessKyc/epf'},
    //     { name: 'Payslip', link: '/dashboard/businessKyc/payslip'},
    //     { name: 'Form 16', link: 'form16' },
    //      { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
    //     { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
    //     { name: 'Bank Account *', link: 'bankAcc' },
    //     { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
    //   ],
    //   isSubmenuVisible: false
    // },

    // {
    //   name: 'Asset Verification',
    //   faIcon: 'assignment_turned_in',
    //   submenu: [

    //     { name: 'Vehicle RC', link:'/dashboard/businessKyc/vehicle'},
    //   ],
    //   isSubmenuVisible: false
    // },


    {
      name: 'Bureau Check',
      icon: 'credit_card',
      submenu: [
        {
          // name: ' Equifax Credit Report',
          // link: '/dashboard/businessKyc/equifax'
            name: 'Customer Credit Report',
        link: '/dashboard/businessKyc/crif-report'
        },

      ]
    },

    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],

  Self_employed_professional: [
    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        {
          name: 'Credit Bureau Report',
          link: '/dashboard/businessKyc/crif-report'
        },
        { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
        { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
        // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
        { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
        // { name:  'CRIF Commercial', link:'/dashboard/businessKyc/crifCommercial'},

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Address Proof',
      icon: 'contacts',
      submenu: [

        // { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
        { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'LPG', link: '/dashboard/businessKyc/lpg' }

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Income Proof',
      faIcon: 'account_balance_wallet',
      submenu: [
        { name: 'EPF', link: '/dashboard/businessKyc/epf' },
        // { name: 'Payslip', link: '/dashboard/businessKyc/payslip'},
        // { name: 'Form 16', link: 'form16' },
        { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
        { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
        { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
        { name: 'Computation', link: '/dashboard/businessKyc/computation' },
        { name: 'Bank Account *', link: 'bankAcc' },
        { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
        // { name: 'Bank Statement - Online *', link: 'BankOnline' },
        // { name: 'Investment / Mutual Fund', link:''},



      ],
      isSubmenuVisible: false
    },

    {
      name: 'Professional ID',
      faIcon: 'folder_shared',
      submenu: [
        { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
        { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
        { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
        { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
        { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


      ],
      isSubmenuVisible: false
    },


    {
      name: 'Asset Verification',
      faIcon: 'assignment_turned_in',
      submenu: [

        { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
        // { name: 'Land Verification'},
        // { name: 'Property'}




      ],
      isSubmenuVisible: false
    },



    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],

  Self_employed_others: [
    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        {
          name: 'Credit Bureau Report',
          link: '/dashboard/businessKyc/crif-report'
        },
        { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
        { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
        // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
        { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
        // { name:  'CRIF Commercial', link:'/dashboard/businessKyc/crifCommercial'},

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Address Proof',
      icon: 'contacts',
      submenu: [

        // { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
        { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'LPG', link: '/dashboard/businessKyc/lpg' }

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Income Proof',
      faIcon: 'account_balance_wallet',
      submenu: [
        { name: 'EPF', link: '/dashboard/businessKyc/epf' },
        // { name: 'Payslip', link: '/dashboard/businessKyc/payslip'},
        { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
        // { name: 'Form 16', link: 'form16' },
        { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
        { name: 'ITR - FETCH *', link: '/dashboard/businessKyc/itrfetch' },
        { name: 'Computation', link: '/dashboard/businessKyc/computation' },
        { name: 'Bank Account *', link: 'bankAcc' },
        { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
        // { name: 'Bank Statement - Online *', link: 'BankOnline' },
        // { name: 'Investment / Mutual Fund', link:''},



      ],
      isSubmenuVisible: false
    },




    {
      name: 'Asset Verification',
      faIcon: 'assignment_turned_in',
      submenu: [

        { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
        // { name: 'Land Verification', },
        // { name: 'Property', }




      ],
      isSubmenuVisible: false
    },

    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],



  salaried_coApp: [

    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        //   {
        //     name: 'Credit Report',
        //   link: '/dashboard/businessKyc/crif-report'
        // },
        // { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
      ],
      isSubmenuVisible: false
    },

    {
      name: 'Loan Application Form',
      icon: 'description',
      link: '/dashboard/businessKyc/savingsForm'
    },


    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },


  ],

  Self_employed_professional_coApp: [
    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar Upload', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        //   {
        //     name: 'Credit Report',
        //   link: '/dashboard/businessKyc/cibil'
        // },
        // { name: 'Passport - NRI', link: '/dashboard/businessKyc/Passport' },
        // { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
        // { name: 'Unit Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        // { name: 'Udyam *', link: '/dashboard/businessKyc/udyam' },
        // { name: 'Shops & Establishment', link: '/dashboard/businessKyc/shops' },
        // { name:  'CRIF Commercial', link:'/dashboard/businessKyc/crifCommercial'},

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Bureau Check',
      icon: 'credit_card',
      submenu: [
        { name: 'Customer Credit Report', link: '/dashboard/businessKyc/crif-report' },

      ]
    },


    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],

  superAdminRoles: [
    { id: 1, rolesvalue: "Loan Sanction Committee" },
    { id: 2, rolesvalue: "MD" },
    { id: 3, rolesvalue: "CGM" },
    { id: 4, rolesvalue: "GM" },
    { id: 5, rolesvalue: "DGM" },
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },
    { id: 9, rolesvalue: "Appraiser" },
  ],

  adminRoles: [
    { id: 2, rolesvalue: "MD" },
    { id: 3, rolesvalue: "CGM" },
    { id: 4, rolesvalue: "GM" },
    { id: 5, rolesvalue: "DGM" },
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },
  ],

  managerRoles: [
    { id: 3, rolesvalue: "CGM" },
    { id: 4, rolesvalue: "GM" },
    { id: 5, rolesvalue: "DGM" },
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },

  ],
  leadRoles: [
    { id: 4, rolesvalue: "GM" },
    { id: 5, rolesvalue: "DGM" },
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },

  ],

    treasuryRoles: [
      {id : 3,rolesvalue: "Cfo" },
      {id : 4,rolesvalue: "Checker" },
      {id : 5,rolesvalue: "Maker" },   
    ],
    companysecratoryRoles: [
      {id : 4,rolesvalue: "Checker" },
      {id : 5,rolesvalue: "Maker" }, 
    ],
  approval: [
      {id : 5,rolesvalue: "Maker" }, 
    ],
  executive: [
    { id: 5, rolesvalue: "DGM" },
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },
  ],
  salesRoles: [
    { id: 6, rolesvalue: "AGM" },
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },

  ],

  credit: [
    // { id: 7, rolesvalue: "Branch Manager / Second Manager" },
    { id: 7, rolesvalue: "Branch Manager" },
    { id: 7, rolesvalue: "Second Manager" },
    { id: 8, rolesvalue: "Staff Assistant" },
  ],

  operationRoles: [
    { id: 8, rolesvalue: "Staff Assistant" }
  ],


  SUPER_ADMIN: [
    { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },
    { name: "Dashboard", icon: "analytics", link: "/dashboard/analysis" },
    { name: "Gold Rate", icon: "payments", link: "/dashboard/gold-rate" },

    //  { name : "Entity Approvals", icon:'how_to_reg', link: '/dashboard/approvals'},
    // { name: ' SI Approvals', link: '/dashboard/si-approvals', icon: 'person' },
    // { name: ' SI Details', link: '/dashboard/si-details', icon: 'person' },
    //  { name: 'Asset Master', icon: 'inventory_2' , submenu : [
    //   { name: `Car`, link: "/dashboard/viewAsset?type=Car", icon: "directions_car" },
    //   { name: `Bike`, link: "/dashboard/viewAsset?type=Bike", icon: "two_wheeler" },
    //   { name: `Truck`, link: "/dashboard/viewAsset?type=Truck", icon: "local_shipping" },
    //   { name: `Tractor`, link: "/dashboard/viewAsset?type=Tractor", icon: "agriculture" },
    // ]},
    //  { name: 'Interest Master', link: "/dashboard/viewAsset?type=rateOfInterest", icon: 'percent' },
    // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
    // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
    // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
    // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
    // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },
  ],


  ADMIN: [
    // { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },
    { name: "Dashboard", icon: "analytics", link: "/dashboard/analysis" },
    { name: "Gold Rate", icon: "payments", link: "/dashboard/gold-rate" },

    //  { name: 'Wallet', icon: 'business_center',link: '/dashboard/wallet'},
    //  { name: 'Asset Master', icon: 'inventory_2' , submenu : [
    //   { name: `Car`, link: "/dashboard/viewAsset?type=Car", icon: "directions_car" },
    //   { name: `Bike`, link: "/dashboard/viewAsset?type=Bike", icon: "two_wheeler" },
    //   { name: `Truck`, link: "/dashboard/viewAsset?type=Truck", icon: "local_shipping" },
    //   { name: `Tractor`, link: "/dashboard/viewAsset?type=Tractor", icon: "agriculture" },
    // ]},
    //  { name: 'Interest Master', link: "/dashboard/viewAsset?type=rateOfInterest", icon: 'percent' },
    // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },
    // { name: 'Summary', link: "/dashboard/home", icon: 'list_alt' },
    // { name: 'Sanctioned Loans', link: "/dashboard/success", icon: 'check_circle' },
    // { name: 'Incomplete', link: "/dashboard/incomplete", icon: 'pending' },
    // { name: 'Failure Cases', link: "/dashboard/failure", icon: "report" },
  ],

  role2: [

    // { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },
    //  { name: 'Wallet', icon: 'business_center',link: '/dashboard/wallet'},
    // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },

  ],

  role3: [

    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },

  ],

  role4: [

    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },

  ],

  role5: [

    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },

  ],

  role6: [

    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    { name: 'Manage Users', icon: 'business_center', link: '/dashboard/manage-admins' },

  ],

  role7: [

    { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    // { name: 'Manage Admins', icon: 'business_center', link: '/dashboard/manage-admins' },
    // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },

  ],

  role8: [

    { name: `Add Customer`, link: "/dashboard/add-customer", icon: "person_add" },
    { name: `View Customers`, link: "/dashboard/view-customer", icon: "group" },
    // { name: 'Manage Admins', icon: 'business_center', link: '/dashboard/manage-admins' },
    // { name: 'MIS', link: "/dashboard/mis", icon: 'description' },

  ],

  role0135_homeLoan: [
    {
      name: 'Add Co-Applicant',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-coapplicants'
    },
    {
      name: 'Add Guarantor',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-guarantors'
    },

    {
      name: 'Personal Details',
      icon: 'contact_page',
      link: '/dashboard/loan/personal'
    },
    {
      name: 'Property Details',
      icon: 'business_center',
      link: '/dashboard/loan/propertyDetails'
    },
    {
      name: 'Income Details',
      icon: 'payments',
      link: '/dashboard/loan/income'
    },

    {
      name: 'Risk Profiling',
      icon: 'analytics',
      link: '/dashboard/loan/riskProfilling'
    },
    {
      name: 'Processing Fee',
      icon: 'payments',
      link: '/dashboard/loan/processingFee'
    },

    {
      name: 'PD + CVR',
      icon: 'domain_verification',
      link: '/dashboard/loan/pd+cvr'
    },
    {
      name: 'Loan Application',
      icon: 'feed',
      // link: 'laas/applications/apply'
    },


    {
      name: 'Upload Application',
      icon: 'upload_file',
      link: '/dashboard/loan/uploadApplication'
    },

    {
      name: 'File Movement',
      icon: 'file_open',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/fileMovement'
    },

  ],

  role2_homeLoan: [
    {
      name: 'Approval',
      icon: 'description',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/approval'
    },


    {
      name: 'Processing Fee',
      icon: 'payments',
      link: '/dashboard/loan/processingFee'
    },
    {
      name: 'Loan Application',
      icon: 'feed',
      // link: 'laas/applications/apply'
    },


    {
      name: 'Upload Application',
      icon: 'upload_file',
      link: '/dashboard/loan/uploadApplication'
    },

    {
      name: 'File Movement',
      icon: 'file_open',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/fileMovement'
    },
  ],

  role4_homeLoan: [

    {
      name: 'Property Details',
      icon: 'business_center',
      link: '/dashboard/loan/propertyDetails'
    },

    {
      name: 'Processing Fee',
      icon: 'payments',
      link: '/dashboard/loan/processingFee'
    },


    {
      name: 'File Movement',
      icon: 'file_open',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/fileMovement'
    },
  ],
  role6_homeLoan: [
    {
      name: 'Add Co-Applicant',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-coapplicants'
    },
    {
      name: 'Add Guarantor',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-guarantors'
    },

    {
      name: 'Personal Details',
      icon: 'contact_page',
      link: '/dashboard/loan/personal'
    },
    {
      name: 'Property Details',
      icon: 'business_center',
      link: '/dashboard/loan/propertyDetails'
    },
    {
      name: 'Income Details',
      icon: 'payments',
      link: '/dashboard/loan/income'
    },

    //  {
    //   name: 'Risk Profiling',
    //   icon: 'analytics',
    //   link: '/dashboard/loan/riskProfilling'
    // },
    {
      name: 'Processing Fee',
      icon: 'payments',
      link: '/dashboard/loan/processingFee'
    },

    {
      name: 'PD + CVR',
      icon: 'domain_verification',
      link: '/dashboard/loan/pd+cvr'
    },
    {
      name: 'Loan Application',
      icon: 'feed',
      // link: 'laas/applications/apply'
    },


    {
      name: 'Upload Application',
      icon: 'upload_file',
      link: '/dashboard/loan/uploadApplication'
    },

    {
      name: 'File Movement',
      icon: 'file_open',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/fileMovement'
    },

  ],
  role78_homeLoan: [
    {
      name: 'Add Co-Applicant',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-coapplicants'
    },
    {
      name: 'Add Guarantor',
      icon: 'supervisor_account',
      link: '/dashboard/loan/view-guarantors'
    },

    {
      name: 'Personal Details',
      icon: 'contact_page',
      link: '/dashboard/loan/personal'
    },
    {
      name: 'Property Details',
      icon: 'business_center',
      link: '/dashboard/loan/propertyDetails'
    },
    {
      name: 'Income Details',
      icon: 'payments',
      link: '/dashboard/loan/income'
    },

    //  {
    //   name: 'Risk Profiling',
    //   icon: 'analytics',
    //   link: '/dashboard/loan/riskProfilling'
    // },
    {
      name: 'Processing Fee',
      icon: 'payments',
      link: '/dashboard/loan/processingFee'
    },

    // {
    //   name: 'PD + CVR',
    //   icon: 'domain_verification',
    //   link: '/dashboard/loan/pd+cvr'
    // },
    {
      name: 'Loan Application',
      icon: 'feed',
      // link: 'laas/applications/apply'
    },


    {
      name: 'Upload Application',
      icon: 'upload_file',
      link: '/dashboard/loan/uploadApplication'
    },

    {
      name: 'File Movement',
      icon: 'file_open',
      // link: 'laas/loans/apply',
      link: '/dashboard/loan/fileMovement'
    },

  ],


  role356_westend: [

    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        // { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
      ],
      isSubmenuVisible: false
    },

    {
      name: 'Address Proof',
      icon: 'contacts',
      submenu: [

        { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
        { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
        { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Income Details',
      faIcon: 'account_balance_wallet',
      submenu: [
        // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
        { name: 'EPF', link: '/dashboard/businessKyc/epf' },
        { name: 'Payslips/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
        { name: 'Form 16', link: 'form16' },
        // // { name: 'Form 26As', link:'form26as'},
        //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
        { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
        { name: 'Bank Account *', link: 'bankAcc' },
        { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
        { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
        { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
        { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
      ],
      isSubmenuVisible: false
    },


    {
      name: 'Business ID/Proof',
      icon: 'work',
      submenu: [
        // { name: 'Business ID/Proof', link: 'business/commercial' },
        { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
        { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
        { name: 'Udyam', link: '/dashboard/businessKyc/udyam' },
        { name: 'Shops & Estd', link: '/dashboard/businessKyc/shops' },
        { name: 'FSSAI', link: '/dashboard/businessKyc/fssai' },
        { name: 'IEC', link: '/dashboard/businessKyc/iec' },
        { name: 'FDA', link: '/dashboard/businessKyc/fda' },

      ],
      isSubmenuVisible: false
    },


    {
      name: 'Professional ID',
      faIcon: 'folder_shared',
      submenu: [
        { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
        { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
        { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
        { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
        { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


      ],
      isSubmenuVisible: false
    },


    {
      name: 'Asset Verification',
      faIcon: 'assignment_turned_in',
      submenu: [

        { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
      ],
      isSubmenuVisible: false
    },

    {
      name: 'Bureau Check',
      icon: 'credit_card',
      submenu: [
        { name: 'Customer Consent Form', link: '/dashboard/businessKyc/crif-report' },

      ]
    },


    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],


  role78_westend: [

    {
      name: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard/businessKyc/dashboard'
    },


    {
      name: 'Fetch Documents From Digilocker',
      icon: 'cloud_download',
      link: '/dashboard/businessKyc/digilocker'
    },

    {
      name: 'KYC',
      icon: 'fingerprint',
      submenu: [
        { name: 'Aadhaar', link: '/dashboard/businessKyc/aadhar' },
        // { name: 'Aadhaar - Verify', link: '/dashboard/businessKyc/aadhar-verify' },
        { name: 'PAN', link: '/dashboard/businessKyc/pan' },
        { name: 'Driving Licence', link: '/dashboard/businessKyc/DL' },
        { name: 'Voter ID', link: '/dashboard/businessKyc/Voter-Id' },
        // { name: 'Passport', link: '/dashboard/businessKyc/Passport' },
      ],
      isSubmenuVisible: false
    },

    {
      name: 'Address Proof',
      icon: 'contacts',
      submenu: [

        { name: 'Telephone bill', link: '/dashboard/businessKyc/tel' },
        { name: 'Elecricity bill *', link: '/dashboard/businessKyc/ebillres' },
        { name: 'LPG', link: '/dashboard/businessKyc/lpg' },
        { name: 'Other Address Proof', link: '/dashboard/businessKyc/otheraddressproof' }

      ],
      isSubmenuVisible: false
    },

    {
      name: 'Income Details',
      faIcon: 'account_balance_wallet',
      submenu: [
        // {name: 'Income Details', link: '/dashboard/businessKyc/income'},
        { name: 'EPF', link: '/dashboard/businessKyc/epf' },
        { name: 'Payslips/Salary Certificate', link: '/dashboard/businessKyc/payslip' },
        { name: 'Form 16', link: 'form16' },
        // // { name: 'Form 26As', link:'form26as'},
        //  { name: 'ITR - Verify *', link: '/dashboard/businessKyc/itr' },
        { name: 'ITR - Online FETCH *', link: '/dashboard/businessKyc/itrfetch' },
        { name: 'Bank Account *', link: 'bankAcc' },
        { name: 'Bank Statement Upload *', link: 'bankStmntUpload' },
        { name: 'Rental Agreement', link: '/dashboard/businessKyc/rental-agreement', tooltip: 'Rental Agreement' },
        { name: 'P & L', link: '/dashboard/businessKyc/pnl', tooltip: 'P & L' },
        { name: 'Balance Sheet', link: '/dashboard/businessKyc/balance-sheet', tooltip: 'Balance Sheet' },
      ],
      isSubmenuVisible: false
    },


    {
      name: 'Business ID/Proof',
      icon: 'work',
      submenu: [
        // { name: 'Business ID/Proof', link: 'business/commercial' },
        { name: 'GST ID', link: '/dashboard/businessKyc/gst-authentication' },
        { name: 'GST (Password based)', link: '/dashboard/businessKyc/gst-pull' },
        { name: 'Udyam', link: '/dashboard/businessKyc/udyam' },
        { name: 'Shops & Estd', link: '/dashboard/businessKyc/shops' },
        { name: 'FSSAI', link: '/dashboard/businessKyc/fssai' },
        { name: 'IEC', link: '/dashboard/businessKyc/iec' },
        { name: 'FDA', link: '/dashboard/businessKyc/fda' },

      ],
      isSubmenuVisible: false
    },


    {
      name: 'Professional ID',
      faIcon: 'folder_shared',
      submenu: [
        { name: 'ICAI', link: '/dashboard/businessKyc/icai' },
        { name: 'ICSI', link: '/dashboard/businessKyc/icsi' },
        { name: 'ICWAI Firm', link: '/dashboard/businessKyc/icwaif' },
        { name: 'ICWAI Membership', link: '/dashboard/businessKyc/icwaim' },
        { name: 'MCI Membership', link: '/dashboard/businessKyc/mci' },


      ],
      isSubmenuVisible: false
    },


    {
      name: 'Asset Verification',
      faIcon: 'assignment_turned_in',
      submenu: [

        { name: 'Vehicle RC', link: '/dashboard/businessKyc/vehicle' },
      ],
      isSubmenuVisible: false
    },

    //      {
    //   name: 'Bureau Check',
    //   icon: 'credit_card',
    //   submenu: [
    //     { name: 'Customer Consent Form', link: '/dashboard/businessKyc/crif-report' },

    //   ]
    // },


    {
      name: 'Validation Report',
      icon: 'fact_check',
      link: '/dashboard/businessKyc/valReport'
    },

  ],

};


